import {
  CitadeleIcon,
  CoopIcon,
  LHVIcon,
  Luminor16Icon,
  LuminorIcon,
  N26Icon,
  RevolutIcon,
  SebIcon,
  SwedbankIcon,
} from "@components/icons";
import { type BankName } from "@services/budget/types";

export const bankCardMetadata: Record<
  BankName,
  {
    color: string;
    icon?: React.FC<React.SVGProps<SVGSVGElement>>;
    iconSmall?: React.FC<React.SVGProps<SVGSVGElement>>;
  }
> = {
  Swedbank: {
    color: "#FFEFE5",
    icon: SwedbankIcon,
    iconSmall: SwedbankIcon,
  },
  SEB: {
    color: "#F0FBEA",
    icon: SebIcon,
    iconSmall: SebIcon,
  },
  Luminor: {
    color: "#F9EBF5",
    icon: LuminorIcon,
    iconSmall: Luminor16Icon,
  },
  Citadele: {
    color: "#FDE8EB",
    icon: CitadeleIcon,
    iconSmall: CitadeleIcon,
  },
  Revolut: {
    color: "#F5F6F8",
    icon: RevolutIcon,
    iconSmall: RevolutIcon,
  },
  LHV: {
    color: "#F5F6F8",
    icon: LHVIcon,
    iconSmall: LHVIcon,
  },
  Coop: {
    color: "#F5F6F8",
    icon: CoopIcon,
    iconSmall: CoopIcon,
  },
  N26: {
    color: "#F5F6F8",
    icon: N26Icon,
    iconSmall: N26Icon,
  },
  Default: {
    color: "#DDE3EA",
    icon: undefined,
    iconSmall: undefined,
  },
};
